import React from 'react';
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

//MUI Component
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Styles
import './styles.scss';

const ConfirmModal = ({ openConfirmModal }) => {
  const {
    open,
    message,
    subMessage = '',
    handleOk,
    loading,
    header,
    icon = null,
    className,
    successButtonName,
    cancelButtonName = '',
    handleClose,
    handleCancelBtn = handleClose,
    svg = null,
    description = '',
    type = '',
    component = null,
    addOnNote = null,
    bodyContent = null,
    successButtonDisabled = false,
    containedIcon = false,
  } = openConfirmModal;
  const successButtonLabel = successButtonName || 'Ok';

  const footer = (
    <>
      <OlcButton variant="secondary" onClick={handleCancelBtn} className="cancelButton">
        {type === 'export' || type === 'payAndProcess'
          ? cancelButtonName || 'Cancel'
          : type === 'leave-campaign-creation'
            ? 'Leave Page'
            : cancelButtonName || 'No'}
      </OlcButton>
      <OlcButton
        variant="primary"
        className={`confirmModalSubmitButton${loading ? ' confirmModalSubmitButton--loading' : ''}`}
        disabled={loading || successButtonDisabled}
        onClick={handleOk}
        aria-busy={loading || undefined}
      >
        <span className="confirmModalSubmitButtonLabel">{successButtonLabel}</span>
        {loading && (
          <CircularProgress
            aria-hidden="true"
            className="confirmModalSubmitButtonSpinner"
            sx={{
              color: 'white',
              width: '20px !important',
              height: '20px !important',
            }}
          />
        )}
      </OlcButton>
    </>
  );

  return (
    <OlcFormModal
      open={open}
      onClose={handleClose}
      title={header}
      className={['genericConfirmModal', 'olcConfirmModal', className].filter(Boolean).join(' ')}
      contentClassName="confirmModalContent"
      footer={footer}
    >
      <Box className="confirmModalBody">
        {(svg || icon || component) && (
          <Box
            className={['submitHeader', containedIcon ? 'containedConfirmModalIcon' : '']
              .filter(Boolean)
              .join(' ')}
          >
            {svg ? (
              <Box className="svgIcon">{svg}</Box>
            ) : component ? (
              <>{component}</>
            ) : (
              icon && <img className="confirmModalIcon" src={icon} alt="icon" />
            )}
          </Box>
        )}
        {addOnNote && <Box className="addOnNote">{addOnNote}</Box>}
        <Box className="modalMessage">
          <Typography component="div">{message}</Typography>
          {description && (
            <Typography
              variant={type === 'release-phone-number' ? 'h6' : 'body1'}
              sx={{
                fontFamily: 'Inter',
                fontWeight: type === 'release-phone-number' ? 700 : 400,
                fontStyle: 'Regular',
                fontSize: 16,
                lineHeight: '100%',
                letterSpacing: 0,
                textAlign: 'center',
                verticalAlign: 'middle',
                marginTop: type === 'release-phone-number' ? '12px' : '0',
              }}
            >
              {description}
            </Typography>
          )}
          {subMessage && <Typography>{subMessage}</Typography>}
        </Box>
        {bodyContent && <Box className="confirmModalBodyContent">{bodyContent}</Box>}
      </Box>
    </OlcFormModal>
  );
};

export default ConfirmModal;
